<style lang="scss" >
@import "resources/sass/v1/abstracts/_variables";

.generic-carousel {
    .tns-ovh {
        overflow: visible;
    }
    .tns-outer {
        position: relative;
    }
    .tns-controls {
        display: inline-block;
        position: absolute;
        right: -8px;
        top: -64px;
        margin-top: 0;
        outline: none !important;

        button {
            position: relative;
            visibility: hidden;
            outline: none !important;
            padding: 0;
            border: 0;

            &:after {
                visibility: visible;
                position: absolute;
                width: 26px;
                height: 11px;
                left: 0;
                transition: transform 0.2s;
            }
        }

        button:first-child {
            &:after {
                content: url("/svg/arrow-left-black.svg");
                transform: scaleX(-1);
            }

            &:hover {
                &:after {
                    transform: translateX(-8px) scaleX(-1);
                }
            }
        }

        button:last-child {
            margin-left: 12px;

            &:after {
                top: -1px;
                left: -1px;
                content: url("/svg/arrow-right-black.svg");
            }

            &:hover {
                &:after {
                    transform: translateX(8px);
                }
            }
        }
    }
}
</style>

<template>
    <div class="generic-carousel">
        <tiny-slider :dots="false" :loop="loop" :rewind="!loop" :auto-width="!loop" :fixed-width="loop" :nav="false" :responsive="{0:{items:1,nav:false,gutter:48},576:{items:1,nav:false,gutter:32},768:{items:2,nav:false,gutter:32}}">
            <slot></slot>
        </tiny-slider>
    </div>
</template>

<script>
import VueTinySlider from 'vue-tiny-slider';

export default {
    components: { 'tiny-slider': VueTinySlider },

    props: {
        loop: {
            type: Boolean,
            required: false,
            default: false
        }
    }
}
</script>